import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import { useMemo } from 'react';
import dayjs from '@/libs/dayjs';

type Props = {
  imEvent: ImEventDto;
};

const Badge: React.FC<{ title: string; color: string }> = ({
  title,
  color
}) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        height: 30,
        width: 70,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: color,
        color: 'white',
        fontWeight: theme.typography.fontWeightBold
      }}
    >
      {title}
    </Box>
  );
};

export const HostingStatus: React.FC<Props> = ({ imEvent }) => {
  const beingHeld = useMemo(() => {
    const today = dayjs.utc().tz('Asia/Tokyo');
    return imEvent.datetimes.some((datetime) =>
      today.isSame(datetime.startsAt, 'day')
    );
  }, [imEvent.datetimes]);

  if (imEvent.canceled) {
    return <Badge title="中止" color="grey" />;
  }
  if (beingHeld) {
    return <Badge title="開催中" color="#fd5404" />;
  }
  return null;
};
